import { pluralizeRussian } from "../../lib/PluralizeRussian";

// Склонение существительного «элемент» по количеству неудавшихся публикаций:
// подпись диалога повтора согласуется с числом перед ней.
export function getFailedItemsWord(count: number): string {
  return pluralizeRussian(count, {
    one: "неудавшегося элемента",
    few: "неудавшихся элементов",
    many: "неудавшихся элементов",
  });
}
